<page-title text="BitOasis OTC Trading Service | BitOasis" i18n-text="@@pageTitle.otcPage">BitOasis OTC Trading Service</page-title>
<site-header class="primary"></site-header>


<header class="header section">
    <div class="section-xs">
        <h1 class="text-heading m-0" i18n="@@front.otcPage.header.title">BitOasis OTC Trading Service,<br/>Trade in large blocks at competitive prices in AED and USD</h1>
        <div class="p-3"></div>
        <p class="m-0" i18n="@@front.otcPage.header.description">Register your interest and start OTC trading with BitOasis today!</p>
        <div class="p-4"></div>
        <a routerLink="/support/otc" class="btn btn-primary btn-main" i18n="@@front.otcPage.header.registerAction">Register Interest</a>
    </div>
</header>

<section class="section section-sm">
    <h2 class="text-title text-center m-0" i18n="@@front.otcPage.features.title">A seamless experience for executing large trades</h2>
    <div class="p-2"></div>
    <p class="text-center text-bold m-0" i18n="@@front.otcPage.features.description">Our OTC Trading Service team will assist you at every step within 24 hours</p>
    
    <div class="p-lg-5 p-4"></div>

    <div class="features">
        <div class="row">
            <div class="col-lg">
                <div class="feature">
                    <div class="img">
                        <img src="assets/images/otc/large-trades.svg" alt="Large trades">
                    </div>
                    <h3 class="title" i18n="@@front.otcPage.features.f1.title">Large Trades</h3>
                    <p i18n="@@front.otcPage.features.f1.description">Execute large orders with a minimum amount of USD 100,000</p>
                </div>
            </div>
            <div class="col-1 p-3"></div>
            <div class="col-lg">
                <div class="feature">
                    <div class="img">
                        <img src="assets/images/otc/competitive-pricing.svg" alt="Large trades">
                    </div>
                    <h3 class="title" i18n="@@front.otcPage.features.f2.title">Competitive Pricing</h3>
                    <p i18n="@@front.otcPage.features.f2.description">Highly competitive pricing with no additional transaction fees</p>
                </div>
            </div>
            <div class="col-1 p-3"></div>
            <div class="col-lg">
                <div class="feature">
                    <div class="img">
                        <img src="assets/images/otc/dedicated-support.svg" alt="Large trades">
                    </div>
                    <h3 class="title" i18n="@@front.otcPage.features.f3.title">Dedicated Support</h3>
                    <p i18n="@@front.otcPage.features.f3.description">Our team works with you throughout the entire process</p>
                </div>
            </div>
        </div>
    </div><!-- .features -->
</section>

<section class="how-it-works section section-sm container">
    <div class="row">
        <div class="col-lg-auto">
            <div class="content">
                <h2 class="title" i18n="@@front.otcPage.howItWorks.title">How it works</h2>
                <p i18n="@@front.otcPage.howItWorks.description">Buy and Sell large amounts of digital assets in a few easy steps</p>
            </div>
        </div><!-- .content -->
        <div class="col-lg">
            <div class="visual">
                <div class="visual-box box1">
                    <div class="number">01</div>
                    <p class="text-lg text-bold" i18n="@@front.otcPage.howItWorks.step1.title">Get in touch with us</p>
                    <p i18n="@@front.otcPage.howItWorks.step1.description">Register your interest and our team will get in touch with you.</p>
                </div>
                <div class="p-lg-3"></div>
                <div class="visual-box box2">
                    <div class="number">02</div>
                    <p class="text-lg text-bold" i18n="@@front.otcPage.howItWorks.step2.title">Complete your verification</p>
                    <p i18n="@@front.otcPage.howItWorks.step2.description">Before you begin OTC trading, you will need to be <a routerLink="/verification/tier-two">T3 verified</a>.</p>
                </div>
                <div class="p-lg-3"></div>
                <div class="visual-box box3">
                    <div class="number">03</div>
                    <p class="text-lg text-bold" i18n="@@front.otcPage.howItWorks.step3.title">Communicate and execute</p>
                    <p i18n="@@front.otcPage.howItWorks.step3.description">Share your trade request with the OTC Trading Service team and start receiving quotes for execution.</p>
                </div>
            </div>
        </div><!-- .visual -->
    </div>
    <div class="visual-btn">
        <a routerLink="/support/otc" class="btn btn-primary btn-main" i18n="@@front.otcPage.howItWorks.registerAction">Register Interest</a>
    </div>
</section>

<section class="container section section-sm requirements">
    <p class="title" i18n="@@front.otcPage.req.title">*Requirements</p>
    <ul>
        <li i18n="@@front.otcPage.req.item1">The minimum transaction amount should be USD 100,000.</li>
        <li i18n="@@front.otcPage.req.item2">Eligibility for OTC trading is subject to AML, KYC and other requirements.</li>
        <li i18n="@@front.otcPage.req.item3">You have to be Tier 3 verified in order to transact an OTC trade.</li>
    </ul>
</section>

<site-footer></site-footer>